export const TestIds = {
  ResponsivePopupPageOverlay: 'ResponsivePopupPageOverlay',
} as const;
